// english

export default {
  deviceModel_title: '设备模型管理',
  deviceMode_base_title: '基础信息',
  deviceMode_config_title: '配置列表',
  deviceMode_params_title: '参数列表',
  deviceMode_control_title: '控制列表',
  deviceMode_config_add_title: '添加配置项',
  deviceMode_config_edit_title: '编辑配置项',
  deviceMode_config_fork_title: '派生配置项',

  deviceMode_params_add_title: '添加参数项',
  deviceMode_params_edit_title: '编辑参数项',
  deviceMode_params_fork_title: '派生参数项',

  deviceMode_control_add_title: '添加控制项',
  deviceMode_control_edit_title: '编辑控制项',
  deviceMode_control_fork_title: '派生控制项',

  deviceMode_model_fork_title: '派生设备模型',
  deviceMode_model_edit_title: '编辑设备模型',
  deviceMode_model_add_title: '添加设备模型',

  // conifrm
  deviceModel_confirm_delete_title: '确定删除该模型?',
  deviceModel_confirm_delete_content: '设备模型名称: {name}',

  deviceModel_confirm_delete_item_title: '确定删除该项?',
  deviceModel_confirm_delete_some_item_title: '确定删除这些项?',

  // table
  deviceModel_table_name: '模型名称',
  deviceModel_table_web: 'WEB',
  deviceModel_table_ssh: 'SSH',
  deviceModel_table_web_ssh: 'WEB/SSH',
  deviceModel_table_group_name: '类别名称',
  deviceModel_table_params: '参数',
  deviceModel_table_param1: '参数 #1',
  deviceModel_table_param2: '参数 #2',
  deviceModel_table_filter_group: '通过类别过滤',
  deviceModel_table_rw_level: '读/写级别',
  deviceModel_table_batch_support: '批量支持',
  deviceModel_table_data_type: '数据类型',
  deviceModel_table_data_range: '数据范围',

  // form
  deviceModel_form_model_name: '设备模型名称',
  deviceModel_form_model_name_placeholder: '请输入设备模型名称',
  deviceModel_form_parent_model: '父模型',
  deviceModel_form_parent_model_placeholder: '请选择一个父模型',
  deviceModel_form_support_ssh: '支持 SSH',
  deviceModel_form_support_web: '支持 WEB',
  deviceModel_form_model_image: '模型图片',
  deviceModel_form_avatar: '图标',
  deviceModel_form_avatar_placeholder: '请选择一个类型图标',

  deviceModel_form_model: '设备模型',
  deviceModel_form_model_all: '所有设备模型',
  deviceModel_form_config_group: '配置类别',
  deviceModel_form_config_group_placeholder: '请选择一个配置类别',
  deviceModel_form_config_item: '配置项',
  deviceModel_form_config_item_placeholder: '请选择一个配置项',
  deviceModel_form_protocol: '协议Key',
  deviceModel_form_protocol_placeholder: '请输入协议Key',
  deviceModel_form_display_priority: '显示优先级',
  deviceModel_form_display_priority_placeholder: '请输入显示优先级数字',
  deviceModel_form_data_read_level: '读取级别',
  deviceModel_form_data_read_level_placeholder: '请输入读取级别',
  deviceModel_form_data_write_level: '写入级别',
  deviceModel_form_data_write_level_placeholder: '请输入写入级别',
  deviceModel_form_data_write_tips: '控制级别必须大于',
  deviceModel_form_input: '可输入',
  deviceModel_form_batch_support: '批量支持',

  deviceModel_form_control_name: '控制项名称',
  deviceModel_form_control_name_placeholder: '请输入控制项名称',
  deviceModel_form_control_type: '控制项类别',
  deviceModel_form_control_type_help:
    '同一设备型号中不能重复的控制命令代码,已有命令：1 - soft reset,2 - hard reset,3 - disable system,4–disable connector(connector Id 由 param 字段指 定),5 – ftp 软件升级(url 由 param 提供),6 – ftp 日志上传(url 由 param 提供),7 – vpn start,8 – vpn stop,9 - 重启CCU(Pilot监控), 10 - Update PLC FW thru FTP',
  deviceModel_form_control_type_placeholder: '请输入控制类型',
  deviceModel_form_control_type_error: '已经被使用，请使用其他值',
  deviceModel_form_control_level: '控制级别',
  deviceModel_form_control_level_placeholder: '请输入控制级别',
  deviceModel_form_control_param1: '参数1名称',
  deviceModel_form_control_param1_placeholder: '请输入参数1的名称',
  deviceModel_form_control_param2: '参数2名称',
  deviceModel_form_control_param2_placeholder: '请输入参数2名称',
  deviceModel_form_control_param_help: '可选',

  deviceModel_alias_title: '设备模型别名',
  deviceModel_alias_description:
    '注：在添加设备模型别名后，本平台所有展示设备模型名称的地方将会展示您所修改的设备模型别名，您也可以通过删除别名来使其复原',
  deviceModel_no_alias: '未添加别名',
  // 原始名
  deviceModel_original_name: '原始名称',
  // 别名
  deviceModel_alias_name: '别名',
  // placeholder
  deviceModel_alias_name_placeholder: '请输入别名',
};
